import { render, staticRenderFns } from "./editmenubutton.vue?vue&type=template&id=5bfd78ea&"
import script from "./editmenubutton.vue?vue&type=script&lang=ts&"
export * from "./editmenubutton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "editmenubutton.vue"
export default component.exports